// src/components/button/StackSelector.tsx

import { MoreHorizTwoTone, MoreVertTwoTone } from '@mui/icons-material'
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material'
import { MouseEvent } from 'react'

type Props = {
  data?: { icon: typeof MoreHorizTwoTone; title: string }[]
  onChange?: (event: MouseEvent<HTMLElement>, value: boolean) => void
  value?: boolean
  disabled?: boolean
}

export const StackSelector = ({
  data = [
    { icon: MoreHorizTwoTone, title: 'horizontal stapeln' },
    { icon: MoreVertTwoTone, title: 'vertikal stapeln' },
  ],
  onChange,
  value,
  disabled = false,
}: Props) => (
  <ToggleButtonGroup
    exclusive
    onChange={onChange}
    value={value}
    disabled={disabled}
  >
    {data.map((item, key) => (
      <ToggleButton key={item.title} value={Boolean(key)}>
        <Tooltip title={item.title}>
          <item.icon />
        </Tooltip>
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
)
